import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-admin-carrierslist',
  templateUrl: './admin-carrierslist.component.html',
  styleUrls: ['./admin-carrierslist.component.scss'],
})
export class AdminCarrierslistComponent implements OnInit {

  constructor() { }

  ngOnInit() { }

}
